<template>
  <div class="video-modal-overlay" @click.self="closeVideoModal">
    <div class="video-modal-content">
      <button class="close-button" @click="closeVideoModal">
        <i class="bi bi-x-lg"></i>
      </button>
      <iframe 
        v-if="videoUrl" 
        :src="videoUrl" 
        frameborder="0" 
        allowfullscreen 
        allow="autoplay; encrypted-media"
      ></iframe>
      <p v-else>No video available.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timer: null,
      isTimerFired: false,
    };
  },
  mounted() {
    // this.timer = setTimeout(() => {
    //   if (!this.isTimerFired) {
    //     this.isTimerFired = true;
    //     this.$emit('video-unlocked', this.videoUrl);
    //   }
    // }, 1200000);  // 20 min
    this.$emit('video-unlocked', this.videoUrl);
  },
  // beforeUnmount() { 
  //   if (this.timer) {
  //     clearTimeout(this.timer);
  //   }
  // },
  methods: {
    closeVideoModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.video-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.video-modal-content {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 800px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

iframe {
  width: 100%;
  height: 600px; 
  border-radius: 6px;
}
</style>